/* eslint-disable react/no-unescaped-entities */

import Layout from '@layout/Layout';
import React, { useEffect } from 'react';
import { Link, Script } from 'gatsby';

import { Helmet } from 'react-helmet';

const DataSecurity = () => {
  return (
    <Layout>
      <Helmet>
        <title>Data Security</title>
      </Helmet>
      <section className="container flex flex-col lg:gap-[40px]">
        <div className="flex w-[100%] items-center justify-center pt-12">
          <h2
            id="data-security"
            className="accent-underline mb-4 w-fit p-0 text-[40px] font-semibold sm:mb-0 lg:text-[51px]"
          >
            Data Security
          </h2>
        </div>
        <div className="my-[60px] flex flex-col md:flex-row">
          <div className="flex flex-1 flex-col">
            <h5 className="text-[24px] font-bold text-info-page-heading">
              Privacy
            </h5>
            <div className="my-[15px] h-[1px] w-[80%] bg-grey-text-footer opacity-50"></div>
            <Link
              className="mb-[16px] text-[18px] leading-[36px] text-grey-text-footer"
              to="/privacy-policy"
            >
              Privacy Policy
            </Link>
            <Link
              to="/cookie-policy"
              className="mb-[16px] scroll-mt-36 text-[18px] leading-[36px] text-grey-text-footer"
            >
              Cookie Policy
            </Link>
            <Link
              className="mb-[16px] text-[18px] leading-[36px] text-grey-text-footer"
              to="/data-security"
            >
              Data Security
            </Link>
          </div>
          <div className="flex flex-[2] flex-col">
            <div className="text-[16px] leading-[26px] text-dark-grey">
              <p className="mb-[31px]">Last Updated: June 25, 2024.</p>
              <p className="mb-[16px]">
                PanelLogic plans, develops and maintains our productivity
                applications and networks with strict security requirements and
                protocols in order to secure your data.
              </p>

              <h6 className="mb-[15px] text-[24px] font-bold leading-[43px] text-info-page-heading">
                Network Security
              </h6>
              <p className="">
                PanelLogic’s network is built from the ground up to meet
                bank-level security best practices:
              </p>
              <ul className="list-disc pl-[30px]">
                <li>
                  We maintain strict network segmentation between production and
                  non-production systems.
                </li>
                <li>
                  Access to our production networks is heavily restricted
                  through the use of firewall rules and requires multi-factor
                  authentication and encrypted connections.
                </li>
                <li>
                  Access to our production networks is limited to a small number
                  of engineers.
                </li>
                <li>
                  We maintain, and all employees and contractors are regularly
                  updated regarding, comprehensive security policies and
                  procedures.
                </li>
                <li>
                  Our leadership is well experienced in fostering a security
                  culture that successfully passes annual independent
                  information security audits. We are planning for an
                  independent SOC2 Type I information security audit later this
                  year.
                </li>
              </ul>

              <h6 className="my-[15px] text-[24px] font-bold leading-[43px] text-info-page-heading">
                Cloud Services
              </h6>

              <p className="mb-[16px]">
                PanelLogic uses Microsoft Azure cloud services for hosting all
                data and functional components of our application systems.
                Intrusion detection and prevention systems monitor traffic on
                all our networks to identify potential security issues.
              </p>

              <h6 className="mb-[15px] text-[24px] font-bold leading-[43px] text-info-page-heading">
                Access to Customer Data
              </h6>
              <p className="mb-[16px]">
                Access to customer data is on a ‘need to access’ basis only.
                PanelLogic treats all customer data as sensitive and we’ve
                implemented stringent controls governing this data.
              </p>
              <p className="mb-[16px]">
                Unauthorized or inappropriate access to customer data is treated
                as a security incident and managed through our incident
                management process. This process includes instructions to notify
                affected customers if a breach of security is detected.
              </p>

              <h6 className="mb-[15px] text-[24px] font-bold leading-[43px] text-info-page-heading">
                Access by Customer Support
              </h6>
              <p className="mb-[30px]">
                Our support teams will only access customer data when necessary
                to answer specific customer questions or to resolve an open
                ticket. All support team member access to data is logged and
                reviewed to ensure compliance with our security policies and
                procedures.
              </p>

              <h6 className="mb-[15px] text-[24px] font-bold leading-[43px] text-info-page-heading">
                Report a Vulnerability
              </h6>
              <p className="mb-[16px]">
                If you believe you have found a security issue or vulnerability,
                which is a weakness in one of our services or infrastructure,
                that could allow an attacker to impact the confidentiality,
                integrity, or availability of the service or infrastructure,
                please submit a report to our security team by sending an email
                to:{' '}
                <a href="mailto:security@panellogic.com">
                  security@panellogic.com
                </a>
                .
              </p>
              <p className="">
                Please include as much information as you can in your email such
                as the following:
              </p>
              <ul className="list-disc pl-[30px]">
                <li>
                  Type of issue (cross-site scripting, SQL injection, remote
                  code execution, etc.)
                </li>
                <li>
                  Your browser and version (e.g. Chrome Version 102.0.5005.61)
                </li>
                <li>
                  The computer or mobile phone operating system and version
                  (e.g. Apple Big Sur 11.6.6)
                </li>
                <li>
                  The potential impact of the vulnerability (i.e. what data can
                  be accessed or modified)
                </li>
                <li>Step-by-step instructions to reproduce the issue</li>
                <li>
                  Any proof-of-concept or exploit code required to reproduce the
                  issue
                </li>
              </ul>

              <p className="mb-[16px]">
                (Note: We do not respond to bulk reports generated by automated
                scanners.)
              </p>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default DataSecurity;

export function Head() {
  return (
    <>
      <title>Data Security</title>
    </>
  );
}
